import axios from "axios";
import Vue from "vue";
import AES from './aes.min'
import Router from "../router/index";
var CryptoJs = require("./crypto.js");
import {
  Message, MessageBox
} from "element-ui";

const closeWindow = () => {
  document.addEventListener("WeixinJSBridgeReady", function () {
    WeixinJSBridge.call("closeWindow");
  }, false);
  WeixinJSBridge.call("closeWindow")
}

axios.defaults.timeout = 15000; //响应时间
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8"; //配置请求头


let loadingInstance = null;

axios.interceptors.request.use(
  (config) => {
    // if (!config.data.loading) {
    //   loadingInstance = Vue.prototype.$toast.loading({
    //     message: "加载中...",
    //     forbidClick: true,
    //     duration: 0,
    //   });
    // }
    let systemInfo = JSON.parse(sessionStorageProxy.getItem('systemInfo'))
    if (systemInfo && systemInfo.hmac == 1) { //如果当前开启了
      let headers = getHmacHeader(config.method, systemInfo.hmacKey)
      config.headers = { //如果开启了hamc
        ...config.headers,
        ...headers
      }
    }
    //可以进行其他操作
    let token = sessionStorageProxy.getItem('token');
    if (token) {
      Object.assign(config.headers, {
        token: token
      })
    }
    config.headers = {
      ...config.headers,
      loginType: "PC"
    };
    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  (res) => {
    //loadingInstance && loadingInstance.clear();
    if (res.data.code == "20003") {
      let loginType = sessionStorageProxy.getItem('loginType')
      let vueConfig = JSON.parse(sessionStorageProxy.getItem('vueConfig'))
      switch (loginType) {
        case 'login':
          Message({
            type: "info",
            message: "登录认证已过期,请重新登录"
          });
          sessionStorageProxy.clear()
          Router.push({
            path: "/login"
          });
          break;
        case 'remLogin':
          MessageBox({
            title: '登录已过期',
            message: '登录认证已过期,请关闭浏览器之后重新登录~',
            callback: () => {
              sessionStorageProxy.clear()
            }
          })
          break;
        case 'cas':
          MessageBox({
            title: '登录已过期',
            message: '当前登录状态已过期，请重新登录~',
            callback: () => {
              sessionStorageProxy.clear()
              window.location.href = `${vueConfig.CASSSERVICE}/static/sso/login?redirectUrl=${(vueConfig.VUESERVICE)}`;
            }
          })
          break;
      }
    }
    //对响应数据做些事
    if (!res.data.success) {
      return Promise.resolve(res);
    }
    return res;
  },
  (error) => {
    Message({
      type: "info",
      message: "登录认证已过期,请重新登录"
    });
    loadingInstance.clear();
    return Promise.reject(error);
  }
);

// 添加Hmac验证

function getHmacHeader(method, HMAC) {
  var id = getUUID();
  var date = new Date().getTime();
  var str = "seat::" + id + "::" + date + "::" + method.toUpperCase();
  var hmacKey = AES.decrypt(HMAC); // hmackey默认值leos3cr3t
  var requestKey = CryptoJs.HmacSHA256(str, hmacKey).toString();
  return {
    "X-request-id": id,
    "X-request-date": date,
    "X-hmac-request-key": requestKey
  };
}

function getUUID() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}

export default {
  fetchPost(url, params, header) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, params, header)
        .then(
          (response) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        )
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchGet(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, params)
        .then(
          (response) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        )
        .catch((error) => {
          reject(error);
        });
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/axios.js